import { MAX_DATA_SOURCE_PREVIEW_ROWS } from 'src/constants/limits';

export const addLimitToSqlQuery = (rawQuery: string) => {
  const alreadyHasLimitAtEnd = rawQuery.match(
    /limit\s+(\d+)(?:\s+offset\s+\d+)?\s*$/i
  );
  if (alreadyHasLimitAtEnd) {
    return {
      limitedQuery: rawQuery,
      resultLimit: parseInt(alreadyHasLimitAtEnd[1]),
    };
  }
  return {
    limitedQuery: `${rawQuery} LIMIT ${MAX_DATA_SOURCE_PREVIEW_ROWS}`,
    resultLimit: MAX_DATA_SOURCE_PREVIEW_ROWS,
  };
};
